import { useState, useEffect } from 'react';
import { db, postsReference } from '../config/firebase';
import { IArticles } from '../interfaces/Articles';
import { doc, getDoc, getDocs, query, QueryCompositeFilterConstraint } from 'firebase/firestore';


const getPosts = async () => {
  return await getDocs(postsReference);
}

const useFirestoreGetPosts = (collectionName: string) => {
  const [data, setData] = useState<IArticles[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const querySnapshot = await getDocs(postsReference);
        const docs = querySnapshot.docs.map(doc => {
          const data = doc.data();
          return {
            uid: data.uid,
            title: data.title,
            date: data.date,
            author: data.author,
            url: data.url
          }
        });
        setData(docs);
      } catch (err) {
        if (err instanceof Error) {
            setError(err.message);
        } else {
            setError('An unknown error occurred.');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [collectionName]);

  return { data, loading, error };
};

const useFirestoreGetPostById = (collectionName: string, postId: string) => {
  const [post, setPost] = useState<IArticles | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const postDoc = await getDoc(doc(db, collectionName, postId));
        if (postDoc.exists()) {
          const data = postDoc.data();
          setPost({
            uid: data.uid,
            title: data.title,
            date: data.date,
            author: data.author,
            url: data.url
          });
        } else {
          setError('Post not found');
        }
      } catch (err) {
        if (err instanceof Error) {
            setError(err.message);
        } else {
            setError('An unknown error occurred.');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [collectionName, postId]);

  return { post, loading, error };
};

export  { useFirestoreGetPosts, useFirestoreGetPostById };
